<template>
    <div>
        <div style="text-align: right; padding-right: 10px">
            <van-icon name="share" size="40" style="transform: rotateY(180deg) rotate(270deg)" color="#1989fa"/>
        </div>

        <div style="padding: 30px; text-align: center; font-size: 16px">
            微信中不支持打开当前页面<br/><br/>
            <div style="margin-top: 10px">如需浏览，请进行如下操作</div><br/>
            <div style="text-align: left; display: inline-block; margin-top: 0px">
                <span style="color: #1989fa; font-size: 20px">①</span> 请点击右上角···按钮<br/><br/>
                <span style="color: #1989fa; font-size: 20px">②</span> 弹出菜单中,选择在浏览器中打开
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "Wp_open_by_browser"
    }
</script>

<style scoped>

</style>